// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_3Cd","cls2":"AuthorsCard-cls2_nsC AuthorsCard-cls1_3Cd","altLook":"AuthorsCard-altLook_F3a"};